import React, { useEffect, useState } from "react";
import brand from "../assets/auth/BrainyCare-Logo.jpg";
import {
  Drawer,
  Icon,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
  Box,
  Avatar,
  Divider,
} from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EventNoteIcon from "@mui/icons-material/EventNote";
import NotificationsIcon from "@mui/icons-material/NotificationsNone";
import { Button } from "@mui/material"; // Example import for material components
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import LogoutIcon from "@mui/icons-material/Logout";
import { Link, useNavigate } from "react-router-dom";
import ChatWrapper from "./chat/chatwrapper";
import useStore from "../store/zustandstore";
import api from "../api/api";
import { eventBus } from "../utils/eventBus";
import { clearPrivileges } from "../reduxtoolkit/userPrivileges";
import { useDispatch, useSelector } from "react-redux";
import { homeIcon } from "./svg";
import { useRecording } from "../context/RecordingContext";
import { OrangeSwitch } from "./customSwitch";
import NoteInstructionsModal from "../user/NoteInstructionsModal";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { set } from "date-fns";
import { setConfig } from "../reduxtoolkit/userconfigslice";
import RequestTimeOffModal from "./requesttimeoffmodal";
import NotificationsModal from "./notificationsmodal";
import dayjs from "dayjs";
import WorkingLocationSelect from "./WorkingLocationSelect";
import { reloadUnlessBusy } from "../utils/deferredNavigation";
import { bsAccessOnly, getPracticeId, kioskStatusShown, practiceFeatures, practiceLogo, practiceProfile, profileMenuItemShown } from "../config/practice";
import { useBsAccess } from "../utils/bsAccess";

const AppHeader = () => {
  const { isGlobalRecording } = useRecording();
  const [chat, setChat] = useState(false);
  const [msgcount, setMsgCount] = useState(0);
  const [threadNotification, setThreadNotificationCount] = useState(0);
  const [notificationcount, setNotificationCount] = useState(0);
  const [imgdata, setimgdata] = useState("");
  const [pendingcount, setPendingcount] = useState(0);
  const userConfig = useSelector((state) => state.userconfig);
  const [showPrices, setShowPrices] = useState(true);
  const [greyCompleted, setGreyCompleted] = useState(true);
  const navigate = useNavigate();
  const setSidenav = useStore((state) => state.setSidenav);
  const setMessagecount = useStore((state) => state.setMessagecount);
  const [requestTimeOffModalOpen, setRequestTimeOffModalOpen] = useState(false);
  const [notificationsModalOpen, setNotificationsModalOpen] = useState(false);
  // Bumped by a location switch made during a recording (no page reload):
  // remounts the chat inbox so it loads the new location's conversations.
  const [locationEpoch, setLocationEpoch] = useState(0);
  // The location menu is open: the header is raised above the chart window
  // (z-50) only then, so the menu opens over it (WorkingLocationSelect).
  const [locationMenuOpen, setLocationMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const homescreenprev = useSelector(
    (state) => state.userPrivileges.homescreen,
  );
  // Side Bar privileges: the Tasks icon only for a user who may open Tasks
  // (the route needs "Tasks"; without it the icon only led to Access Denied).
  const sidebarPrivileges = useSelector(
    (state) => state.userPrivileges.privileges,
  );
  const canOpenTasks = Array.isArray(sidebarPrivileges) && sidebarPrivileges.includes("Tasks");
  // Profile-menu entries the practice keeps (7825: View profile, Note
  // instructions for BlinkScribe users, Logout; 9928: all of them).
  const bsAccess = useBsAccess();
  const menuShows = (label) =>
    profileMenuItemShown(label) && (!bsAccessOnly(label) || bsAccess === "yes");
  const showMenuSwitches = menuShows("Show prices") || menuShows("Grey out completed tasks");

  const [updatingconfig, setUpdatingConfig] = useState("");
  const practiseid = getPracticeId();

  const handleToggle = async (key, value) => {
    if (!userConfig?.id) return;

    // safely handle null config (default all values to false)
    const currentConfig = userConfig?.config || {
      show_prices: false,
      tasks_completed: false,
    };

    // update local state for instant UI feedback
    if (key === "show_prices") setShowPrices(value);
    if (key === "tasks_completed") setGreyCompleted(value);

    // build payload safely
    const payload = {
      rowid: userConfig.id,
      show_prices: key === "show_prices" ? value : !!currentConfig.show_prices,
      tasks_completed:
        key === "tasks_completed" ? value : !!currentConfig.tasks_completed,
    };

    try {
      setUpdatingConfig(key);

      // update backend
      await api.put(`/v1/${practiseid}/user/config`, payload);

      // update redux safely
      const updatedConfig = {
        ...userConfig,
        config: {
          ...userConfig.config,
          show_prices: payload.show_prices,
          tasks_completed: payload.tasks_completed,
        },
      };

      dispatch(setConfig(updatedConfig));
    } catch (err) {
      console.error("Failed to update config", err);
    } finally {
      setUpdatingConfig(false);
    }
  };

  const fetchCount = async () => {
    // No user yet (the header mounts before the login's config arrives):
    // dbscounts needs the userid (400 without it); the effect below re-runs
    // this once the id is in.
    if (!userConfig?.id) return;
    try {
      const response = await api.post(
        `/v1/${getPracticeId()}/appointments/dbscounts`,
        {
          type: "APT",
          userid: userConfig?.id,
          searchdate: new Date().toISOString().split("T")[0],
        },
      );
      const startDate = dayjs().subtract(1, "month").format("YYYY-MM-DD");
      const endDate = dayjs().add(1, "month").format("YYYY-MM-DD");

      const notificationresponse = await api.get(
        `/v1/${practiseid}/pto/counts`,
        {
          params: { start_date: startDate, end_date: endDate },
        },
      );
      if (notificationresponse.status == 200) {
        setNotificationCount(notificationresponse?.data?.total_pending || 0);
      }
      if (response.status == 200) {
        if (response?.data?.length) {
          console.log("response?.data?.length", response?.data);

          setMsgCount(response?.data[0]?.messages || 0);
          // Call notes (7825): the side nav's Communication badge reads it too.
          if (practiceFeatures().callNotes) setMessagecount(response?.data[0]?.messages || 0);
          setThreadNotificationCount(response?.data[0]?.notifications || 0);
          setPendingcount(response?.data[0]?.pendingtasks || 0);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };
  const fetchuserimg = async () => {
    try {
      const imgResponse = await api.get(
        `/v1/${practiseid}/user/${userConfig.id}/profile-picture?ts=${Date.now()}`,
        { responseType: "blob" },
      );

      if (imgResponse) {
        const blobUrl = URL.createObjectURL(imgResponse);
        setimgdata(blobUrl); // You can now pass this as <img src={imgdata} />
      }
      // do something with response.data
    } catch (error) {
      console.error("Error fetching user", error);
    } finally {
    }
  };
  useEffect(() => {
    if (userConfig && userConfig.id) {
      fetchuserimg();
    }
  }, [userConfig]);
  // Refetch once the logged-in user's config arrives — on a fresh login the
  // header mounts before userConfig loads, so the mount-time fetch ran with
  // an undefined userid and the badges stayed empty until a manual refresh
  // (QA 2026-08-20).
  useEffect(() => {
    fetchCount();
  }, [userConfig?.id]);
  // A reply to an unread conversation (personalchart emits REFRESH_CHAT_LIST)
  // drops the server's unread count: re-read the badges then, as OSA's build
  // did, instead of keeping the old count until a full reload.
  // REFRESH_HEADER_COUNTS lets any other screen ask for the same.
  useEffect(() => {
    const refresh = () => fetchCount();
    eventBus.on("REFRESH_CHAT_LIST", refresh);
    eventBus.on("REFRESH_HEADER_COUNTS", refresh);
    return () => {
      eventBus.off("REFRESH_CHAT_LIST", refresh);
      eventBus.off("REFRESH_HEADER_COUNTS", refresh);
    };
  }, [userConfig?.id]);

  // Kiosk status for the header indicator: the same feed the dashboard's
  // kiosk icons read (/kiosk/status, one row per kiosk with showStatus
  // "Online" / "Offline"), polled every minute. Off where the practice turns
  // the kiosk icons off (7825).
  const kioskShown = kioskStatusShown();
  const [kiosks, setKiosks] = useState(null);
  useEffect(() => {
    if (!kioskShown) return undefined;
    let alive = true;
    const load = async () => {
      try {
        const res = await api.get(`/v1/${getPracticeId()}/kiosk/status`);
        if (alive) setKiosks(res?.status === 200 && Array.isArray(res.data) ? res.data : []);
      } catch (e) {
        if (alive) setKiosks([]);
      }
    };
    load();
    const id = setInterval(load, 60 * 1000);
    return () => {
      alive = false;
      clearInterval(id);
    };
  }, [kioskShown]);
  const kioskOnline = (kiosks || []).filter((k) => String(k?.showStatus).toLowerCase() === "online").length;
  const kioskState = !kiosks || kiosks.length === 0 ? "none" : kioskOnline > 0 ? "online" : "offline";
  const kioskTitle =
    kioskState === "none"
      ? "Kiosk: no kiosk reporting"
      : kiosks.map((k) => `${k.serial_number || "Kiosk"}: ${k.showStatus || "Unknown"}`).join("\n");

  const [profileMenu, setProfileMenu] = useState(false);
  const [noteInstructionsOpen, setNoteInstructionsOpen] = useState(false);
  const handlelogout = () => {
    dispatch(clearPrivileges());
    localStorage.removeItem("auth");
    navigate("/sign-in/");
  };
  const handleProfileMenu = (event) => {
    if (profileMenu) {
      setProfileMenu(null);
      navigate("manage-profile");
    } else {
      setProfileMenu(event.currentTarget);
    }
  };

  // Function to open the modal
  const handleClickRequestTimeOffOpen = () => {
    setRequestTimeOffModalOpen(true);
  };

  // Function to close the modal
  const handleCloseRequestTimeOff = () => {
    setRequestTimeOffModalOpen(false);
  };

  const handleClickNotificationsOpen = () => {
    setNotificationsModalOpen(true);
  };
  const handleCloseNotifications = () => {
    setNotificationsModalOpen(false);
  };

  const ProfileMenuPopUp = () => {
    return (
      <Menu
        anchorEl={profileMenu}
        anchorReference={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        open={Boolean(profileMenu)}
        onClose={() => setProfileMenu(null)}
        sx={{ mt: 2 }}
        PaperProps={{
          sx: {
            width: 290,
            borderRadius: 5,
            boxShadow: "0px 8px 24px rgba(0,0,0,0.18)",
            overflow: "visible",
          },
        }}
      >
        <Box
          sx={{
            px: 2,
            py: 1,
            pb: 1.5,
            display: "flex",
            alignItems: "center",
            gap: 1.5,
          }}
        >
          <Avatar
            src={imgdata || undefined}
            alt={userConfig?.username || ""}
            sx={{
              width: 44,
              height: 44,
              bgcolor: "#E5E7EB",
              color: "#111827",
              fontWeight: 600,
            }}
          >
            {!imgdata &&
              userConfig?.username
                ?.split(" ")
                .map((w) => w[0])
                .slice(0, 2)
                .join("")}
          </Avatar>
          <Box>
            <Typography
              sx={{
                fontSize: 18,
                fontWeight: 500,
                fontFamily: "Inter, sans-serif",
                color: "#262527",
                lineHeight: 1.2,
              }}
            >
              {userConfig?.username || ""}
            </Typography>
            <Typography
              sx={{
                fontSize: 15,
                fontWeight: 400,
                fontFamily: "Inter, sans-serif",
                color: "#5A5D6C",
                mt: 0.3,
              }}
            >
              {userConfig.role}
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ my: 0.5 }} />

        {/* View profile */}
        <MenuItem
          onClick={() => {
            setProfileMenu(null);
            navigate("manage-profile");
          }}
        >
          <ListItemIcon>
            <PersonOutlineIcon />
          </ListItemIcon>
          <ListItemText
            primary={<Typography variant="body2">View profile</Typography>}
          />
        </MenuItem>

        {/* Request Time off */}
        {menuShows("Request time off") && (
        <MenuItem
          onClick={() => {
            handleClickRequestTimeOffOpen();
            setProfileMenu(null);
          }}
        >
          <ListItemIcon>
            <EventNoteIcon />
          </ListItemIcon>
          <ListItemText
            primary={<Typography variant="body2">Request time off</Typography>}
          />
        </MenuItem>
        )}

        {/* Note Instructions — per-provider AI commands / condition templates */}
        {menuShows("Note instructions") && (
        <MenuItem
          onClick={() => {
            setNoteInstructionsOpen(true);
            setProfileMenu(null);
          }}
        >
          <ListItemIcon>
            <DescriptionOutlinedIcon />
          </ListItemIcon>
          <ListItemText
            primary={<Typography variant="body2">Note instructions</Typography>}
          />
        </MenuItem>
        )}

        {showMenuSwitches && <Divider sx={{ my: 0.5 }} />}

        {/* Show prices switch */}
        {menuShows("Show prices") && (
        <MenuItem disableRipple disableGutters>
          <Box
            sx={{
              px: 2,
              py: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Typography sx={{ fontSize: 14, flex: 1 }}>Show prices</Typography>
            <OrangeSwitch
              checked={!!userConfig?.config?.show_prices} // safely converts to true/false
              onChange={(e) => handleToggle("show_prices", e.target.checked)}
              loading={updatingconfig === "show_prices"}
            />
          </Box>
        </MenuItem>
        )}

        {/* Grey out completed tasks switch */}
        {menuShows("Grey out completed tasks") && (
        <MenuItem disableRipple disableGutters>
          <Box
            sx={{
              px: 2,
              py: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Typography sx={{ fontSize: 14, flex: 1 }}>
              Grey out completed tasks
            </Typography>
            <OrangeSwitch
              checked={!!userConfig?.config?.tasks_completed} // safely coerce to boolean
              onChange={(e) =>
                handleToggle("tasks_completed", e.target.checked)
              }
              loading={updatingconfig === "tasks_completed"}
            />
          </Box>
        </MenuItem>
        )}

        <Divider sx={{ my: 0.5 }} />

        {/* Logout */}
        <MenuItem
          onClick={() => {
            setProfileMenu(null);
            handlelogout();
          }}
        >
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText
            primary={<Typography variant="body2">Logout</Typography>}
          />
        </MenuItem>
      </Menu>
    );
  };

  return (
    <>
      {/* z-20 as before, so every in-app popup (plain `fixed z-50` modals,
          e.g. the P-Card) covers the header and the header is not clickable
          over them. Only while the location menu is open is it raised to
          z-[60], above the chart window and the side nav rail (z-50), so the
          menu opens over them (review 10-06 B2). MUI dialogs (1300) cover it
          either way. */}
      <div className={`w-full h-16 sticky ${locationMenuOpen ? "z-[60]" : "z-20"} `}>
        <div className="fixed w-full h-16 top-0 left-0 bg-[#1d2951] rounded-b-lg flex items-center justify-between px-4">
          <div className="flex items-center gap-[18px]">
          <img
            src={practiceLogo(brand)}
            alt="Brand Logo"
            onClick={() => {
              navigate("/landing");
              if (!isGlobalRecording) reloadUnlessBusy(); // not while a note processes or a voice recording runs
            }}
            // A practice's own logo (7825: blue on transparent) sits on a white
            // chip so it reads on the navy bar; C-HIM's mark is unchanged.
            className={practiceProfile().logo ? "h-12 cursor-pointer bg-white rounded-md px-1" : "h-8 cursor-pointer"}
          />
            {/* Working-location switcher (Odessa/Frisco). Config is read live
                per request server-side, so a full reload after switching makes
                every location-scoped view follow (user request 2026-08-20) --
                except during a recording, when the views refresh in place and
                the reload waits: after the recording it runs when the chart
                closes, on the notice's Refresh, or at the next page change /
                tab return -- never by surprise (2026-09-30). */}
            <WorkingLocationSelect
              onOpenChange={setLocationMenuOpen}
              onSwitchedInPlace={(dep, info) => {
                // Not while a voice message is being recorded in the chat:
                // the remount would end it.
                if (!info?.localRecording) setLocationEpoch((n) => n + 1);
                fetchCount();
              }}
            />
          </div>
          <div className="flex items-center space-x-5">
            {/* Kiosk status: monitor icon with a status dot on its corner
                (green online, red offline, grey when no kiosk reports). */}
            {kioskShown && (
            <div
              className={`bmkiosk ${kioskState}`}
              role="status"
              aria-label={kioskState === "online" ? "Kiosk online" : kioskState === "offline" ? "Kiosk offline" : "No kiosk reporting"}
              title={kioskTitle}
            >
              <span className="bmkiosk-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="4" width="18" height="12" rx="2" />
                  <path d="M8 20h8M12 16v4" />
                </svg>
                <span className="bmkiosk-dot" />
              </span>
              Kiosk
            </div>
            )}
            {homescreenprev?.includes("Notifications") && (
              <div className="relative">
                <button
                  className="cursor-pointer flex items-center justify-center w-6 h-6 text-white relative"
                  onClick={() => {
                    handleClickNotificationsOpen();
                  }}
                >
                  <NotificationsIcon />

                  {notificationcount + threadNotification > 0 && (
                    <div className="absolute -top-2 -right-2 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-[#E17954] px-1">
                      <span className="text-[11px] font-bold leading-none text-white">
                        {notificationcount + threadNotification}
                      </span>
                    </div>
                  )}
                </button>
              </div>
            )}

            {/* Home Icon */}
            <button
              className="cursor-pointer flex items-center justify-center w-6 h-6 text-white"
              onClick={() => {
                navigate("/landing");
                if (!isGlobalRecording) reloadUnlessBusy(); // not while a note processes or a voice recording runs
              }}
            >
              {homeIcon}
            </button>

            {/* Tasks Icon with Badge (users with the Tasks privilege) */}
            {canOpenTasks && (
            <div
              className="relative cursor-pointer flex items-center justify-center w-6 h-6 text-white"
              onClick={() => {
                navigate("/tasks");
                setSidenav(true);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                className="w-full h-full"
              >
                <path
                  d="M3 6h14M3 11h14M3 16h8"
                  stroke="currentColor"
                  strokeWidth="1.9"
                  strokeLinecap="round"
                />
                <path
                  d="M14.5 17.2l2.2 2.3 4.3-4.6"
                  stroke="currentColor"
                  strokeWidth="1.9"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                </svg>
              {pendingcount > 0 && (
                <div className="absolute -top-2 -right-2 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-[#E17954] px-1">
                  <span className="text-[11px] font-bold leading-none text-white">{pendingcount}</span>
                </div>
              )}
            </div>
            )}

            {/* Chat Icon */}
            <div
              className="relative cursor-pointer flex items-center justify-center w-6 h-6 text-white"
              onClick={() => {
                if (chat) return;
                setChat(true);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                className="w-full h-full"
              >
                <path
                  d="M20.5 12.3c0 3.9-3.8 7.1-8.5 7.1-1 0-2-.15-2.9-.42L4 20.5l1.3-3.4A6.7 6.7 0 0 1 3.5 12.3C3.5 8.4 7.3 5.2 12 5.2s8.5 3.2 8.5 7.1Z"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinejoin="round"
                />
                <path
                  d="M8.6 10.8h6.8M8.6 14h4.3"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                />
              </svg>
              {msgcount > 0 && (
                <div className="absolute -top-2 -right-2 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-[#E17954] px-1">
                  <span className="text-[11px] font-bold leading-none text-white">{msgcount}</span>
                </div>
              )}
            </div>

            {/* Profile Icon */}
            <div
              className="cursor-pointer flex items-center justify-center w-6 h-6 text-white"
              onClick={handleProfileMenu}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 33 33"
                fill="none"
                className="w-full h-full"
              >
                <path
                  d="M16.2648 15.8962C18.4486 15.8962 20.3397 15.1129 21.8848 13.5676C23.4299 12.0225 24.2132 10.1319 24.2132 7.94784C24.2132 5.7645 23.4299 3.87372 21.8845 2.32811C20.3392 0.783253 18.4484 0 16.2648 0C14.0807 0 12.1901 0.783253 10.645 2.32836C9.09991 3.87347 8.31641 5.76425 8.31641 7.94784C8.31641 10.1319 9.09991 12.0227 10.6453 13.5678C12.1906 15.1127 14.0814 15.8962 16.2648 15.8962Z"
                  fill="currentColor"
                />
                <path
                  d="M30.1724 25.3753C30.1278 24.7323 30.0377 24.0308 29.905 23.2901C29.771 22.5439 29.5986 21.8384 29.3921 21.1937C29.1789 20.5272 28.8888 19.8691 28.5303 19.2384C28.1582 18.5838 27.7211 18.0138 27.2307 17.5448C26.7178 17.0541 26.0899 16.6596 25.3638 16.3718C24.6402 16.0855 23.8383 15.9405 22.9806 15.9405C22.6437 15.9405 22.3179 16.0787 21.6887 16.4883C21.3015 16.7409 20.8486 17.0329 20.343 17.3559C19.9107 17.6314 19.3251 17.8894 18.6018 18.1231C17.8961 18.3514 17.1795 18.4673 16.4723 18.4673C15.7651 18.4673 15.0488 18.3514 14.3423 18.1231C13.6198 17.8897 13.0341 17.6316 12.6023 17.3562C12.1016 17.0362 11.6484 16.7441 11.2554 16.4881C10.627 16.0785 10.3009 15.9402 9.96405 15.9402C9.10602 15.9402 8.30438 16.0855 7.58105 16.372C6.85545 16.6593 6.22728 17.0538 5.71392 17.545C5.22372 18.0143 4.7864 18.5841 4.41479 19.2384C4.05652 19.8691 3.76648 20.527 3.55298 21.1939C3.34678 21.8387 3.17432 22.5439 3.04037 23.2901C2.90769 24.0298 2.81756 24.7315 2.773 25.376C2.72919 26.0075 2.70703 26.6628 2.70703 27.3247C2.70703 29.0473 3.25463 30.4419 4.33447 31.4704C5.40097 32.4852 6.81214 33.0001 8.52821 33.0001H24.4179C26.134 33.0001 27.5446 32.4855 28.6114 31.4704C29.6915 30.4426 30.2391 29.0478 30.2391 27.3245C30.2388 26.6596 30.2164 26.0037 30.1724 25.3753Z"
                  fill="currentColor"
                />
              </svg>
            </div>
          </div>

          {ProfileMenuPopUp()}
        </div>
      </div>

      {requestTimeOffModalOpen && (
        <RequestTimeOffModal
          open={requestTimeOffModalOpen}
          user={userConfig}
          fetchCount={fetchCount}
          onClose={handleCloseRequestTimeOff}
        />
      )}

      {noteInstructionsOpen && (
        <NoteInstructionsModal
          open={noteInstructionsOpen}
          onClose={() => setNoteInstructionsOpen(false)}
        />
      )}

      <NotificationsModal
        open={notificationsModalOpen}
        fetchCount={fetchCount}
        onClose={handleCloseNotifications}
        threadNotificationCount={threadNotification}
      />

      {chat ? (
        <ChatWrapper
          key={`chat-${locationEpoch}`}
          setChat={setChat}
          patientdata={""}
          flow={"chat"}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default AppHeader;
